module.exports = __webpack_public_path__ + "img/mastercard.c.9bee7996.png";